import { ChangeEventHandler } from "react";
import SANGJO_PRODUCTS from "@/constants/grouped_sangjo_products.json";
import RefundCalculatorSelect from "./RefundCalculatorSelect";

interface RefundCalculatorSangjoProductSelectProps {
  id: string;
  label: string;
  sangjoId: keyof typeof SANGJO_PRODUCTS | "";
  sangjoProductId: string;
  onChange: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
}

export const RefundCalculatorSangjoProductSelect = ({
  id,
  label,
  sangjoId,
  sangjoProductId,
  onChange,
}: RefundCalculatorSangjoProductSelectProps) => {
  const sangjoProducts = sangjoId ? SANGJO_PRODUCTS[sangjoId] : [];

  const sangjoProductSelectItems = sangjoProducts
    ? Object.entries(sangjoProducts).map(([_, sangjoProduct]) => {
        const barIndex = sangjoProduct.productName.indexOf("-");

        const parsingSangjoProductName =
          barIndex > -1
            ? sangjoProduct.productName.substring(0, barIndex)
            : sangjoProduct.productName;

        const parsingSangjoProductMonthPaymentPrice = sangjoProduct.monthPaymentPrice
          ? ` (월 ${Number(
              sangjoProduct.monthPaymentPrice.replaceAll(",", ""),
            ).toLocaleString()}원)`
          : "";

        return {
          text: parsingSangjoProductName + parsingSangjoProductMonthPaymentPrice,
          value: sangjoProduct.id,
        };
      })
    : undefined;

  return (
    <RefundCalculatorSelect
      id={id}
      label={label}
      value={sangjoProductId}
      items={sangjoProductSelectItems}
      onChange={onChange}
    />
  );
};
